import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SapServiceEntrySheetParameterService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  SapServiceEntrySheetParameterCreateDto,
  SapServiceEntrySheetParameterDto,
  SapServiceEntrySheetParameterExcelDownloadDto,
  SapServiceEntrySheetParameterUpdateDto,
} from '../proxy/controlling/dtos/sap-service-entry-sheet-parameter';
import { SAPSERVICEENTRYSHEETPARAMETER_CONFIG, SAPSERVICEENTRYSHEETPARAMETER_FIELDS } from './sap-service-entry-sheet-parameter.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-sap-service-entry-sheet-parameter',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, SapServiceEntrySheetParameterService, ConfirmationService],
  templateUrl: './sap-service-entry-sheet-parameter.html',
  styleUrl: './sap-service-entry-sheet-parameter.scss',
})
export class SapServiceEntrySheetParameter extends BaseHierarchicalCrudComponent<
  SapServiceEntrySheetParameterDto,
  SapServiceEntrySheetParameterCreateDto,
  SapServiceEntrySheetParameterUpdateDto,
  SapServiceEntrySheetParameterExcelDownloadDto
> {
  service = inject(SapServiceEntrySheetParameterService);
  config = SAPSERVICEENTRYSHEETPARAMETER_CONFIG;
  fields = SAPSERVICEENTRYSHEETPARAMETER_FIELDS;

  protected prepareUpdateDto(data: any, selected: SapServiceEntrySheetParameterDto): SapServiceEntrySheetParameterUpdateDto {
    return {
      ...data,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'SapServiceEntrySheetParameter';
  }
}
